import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-16339 — a media library folder: where an item lives (one folder per
 * item). Folders nest. A folder belongs to one brand or is Shared (null),
 * like the items in it.
 */
@Index('idx_media_folder_parent', ['fkMediaFolderIdParent'])
@Entity('media_folder')
export class MediaFolderEntity extends BaseEntity {
	@Column({
		type: 'varchar',
		name: 'name',
		length: 120,
		charset: 'utf8mb4',
		collation: 'utf8mb4_0900_ai_ci',
	})
	public name!: string;

	@Column('int', {
		name: 'fk_media_folder__id_parent',
		unsigned: true,
		nullable: true,
	})
	public fkMediaFolderIdParent!: number | null;

	@Column('int', { name: 'fk_brand__id', unsigned: true, nullable: true })
	public fkBrandId!: number | null;
}
